export default function get3Dpie(series) {
  console.log('series', series)
  let size = 190
  if (series[0].data[0][1] == 0 && series[0].data[1][1] == 0 && series[0].data[2][1] == 0) {
    size = 0
  }
  let opt = {
    colors: ["#00EBCA", "#009BFA", "#004CFF", "#52c41a", "#df9d53", "#ffffff"],
    chart: {
      type: "pie",
      backgroundColor: "transparent",
      options3d: {
        enabled: true, // 是否启用 3D 功能，默认是 false，设置为 true 开启 3D 功能
        alpha: 62, // 内旋转角度
        beta: 0, // 外旋转角度
      },
      marginBottom: 50
    },
    title: {
      text: "",
    },
    credits: {
      enabled: false
    },
    tooltip: {
      pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>",
    },
    legend: {
      show: false,
      verticalAlign: 'bottom',
      y: 10,
      itemStyle: {
        color: "#fff",
        fontSize: '16px'
      }
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: "pointer",
        depth: 38,
        size: size,
        dataLabels: {
          enabled: true,
          // format: '<p>{point.name}:</p><p>{point.percentage:.1f} %</p>',
          style: {
            color: "#FFF",
            textOutline: "none",
          },
          lineStyle: {
            color: '#fff',
            width: 2
          },
          useHTML: true, //使用formatter内的标签和样式
          formatter: function () {
            //this 为当前的点（扇区）对象，可以通过  console.log(this) 来查看详细信息
            return (
              '<div>' +
              '<p><span style="font-size: 28px;margin-right: 4px;">' +
              this.y + "</div>"
            );
          },
        },
        showInLegend: true,
      },
    },
    series,
  }

  return opt
}
